import * as React from 'react';

import css from './dialog.css';
import {classify} from 'src/utils/classify';


export type MaskProps = {
  className?: string;
};

export const Mask = ({className}: MaskProps) => (
  <div className={classify(css.mask, className)}></div>
);
export type DialogProps = {
  classNames?: {
    container?: string;
    content?: string;
  };
  children: React.ReactNode;
  noMask?: boolean;
  maskProps?: MaskProps;
};

export const Dialog = ({
  classNames,
  children,
  noMask = false,
  maskProps = {},
}: DialogProps) => (
  <>
    {!noMask && <Mask {...maskProps} />}
    <div className={classify(css.container, classNames?.container)}>
      <div className={classify(css.content, classNames?.content)}>
        {children}
      </div>
    </div>
  </>
);
